
export const NoticeList = [
            {
                id:3,
                title:"Admissions Open For Class NC to Class IX and XI For Session 2026-27  ",
                notice:"/notice/1.pdf"
            },
            // {
            //     id:1,
            //     title:"School Reopens on Jan 19",
            //     notice:"#"
            // },
            // {
            //     id:2,
            //     title:"Class XII Practical Date Sheet ",
            //     notice:"/notice/practical.pdf"
            // },
            // {
            //     id:6,
            //     title:"Co-Currlicular Activities ",
            //     notice:"3.pdf"
            // },

        ]
    

